const dashboard = {
  dashboard: {
    welcome: "Welcome",
    subtitle: "Your Purple Star Astrology analytics and tools",
    recentResults: "Recent Results",
    myChart: "My Purple Star Chart",
    calculateForOthers: "Calculate for Others",
    learningResources: "Learning Resources",
    upcomingEvents: "Upcoming Events",
    viewChart: "View Chart",
    newCalculation: "New Calculation",
    exploreResources: "Explore Resources",
    noResults: "No results yet",
    startCalculating: "Start by creating a new chart calculation",
    viewYourChart: "View and analyze your personal Purple Star Astrology chart",
    createChartForOthers: "Create and save charts for friends, family, or clients",
    accessResources: "Access educational content and reference materials",
    noEvents: "No upcoming events",
    checkBackLater: "Check back later for scheduled events and classes",
    viewAll: "View All",
    viewNow: "View Now",
    startNow: "Start Now",
    explore: "Explore",
    register: "Register",
    quickActions: "Quick Actions",
    popularResources: "Popular Resources",
    updatedAgo: "Updated {{time}} ago",
    savedProfiles: "{{count}} saved profiles",
    newBadge: "New",
    resourceLinks: {
      basics: "Introduction to 紫微斗数 Basics",
      palaceSystem: "Understanding the 12 Palace System",
      starTypes: "Main Stars and Their Influences"
    },
    actions: {
      myChart: {
        title: "My Chart",
        description: "View your personal Purple Star Astrology chart"
      },
      calculate: {
        title: "Calculate",
        description: "Generate charts for others"
      }
    },
    table: {
      name: "Name",
      date: "Date",
      type: "Type",
      action: "Action",
      view: "View",
      delete: "Delete",
      gender: "Gender",
      male: "Male",
      female: "Female",
      self: "Self",
      other: "Other"
    },
    deleteConfirmTitle: "Delete Profile",
    deleteConfirmMessage: "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
    deleteSuccess: "Profile \"{{name}}\" has been deleted successfully.",
    deleteError: "Failed to delete profile. Please try again.",
    emptyState: {
      title: "No results yet",
      description: "Get started by creating a new chart calculation.",
      action: "New Calculation"
    }
  },
};

export default dashboard; 